module.exports = __webpack_public_path__ + "img/pof.6a5d9bcb.webp";